module.exports = __webpack_public_path__ + "static/forms-multiple-fields-progress-dont-c2d5a73862edd48d187658e317477c6a.png";